export default {
  'EXECUTING_CODE': 'Running your code...',
  'EXECUTION_ERROR': 'Code cannot be executed. Network connection to server cannot be established.\n',
};
